<template>
  <div class="modal-overlay" @click="onOverlayClick">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">Recording – {{ audioId }}</h5>
          <button type="button" class="close-btn" @click="onHidden">
            <span>&times;</span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">           
            <div class="audio-controls">
               <div class="audio-player-container">
              <audio controls style="width: 100%;">
                <source :src="audioUrl" type="audio/mpeg">
              </audio>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AudioModal',
  props: {
    audioId: {
      type: [Number, String],
      required: true,
    },
    audioUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    onHidden() {
      this.$emit('close');
    },
    onOverlayClick() {
      this.onHidden();
    }
  }
};
</script>

<style scoped>
.modal-overlay  {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.modal-body {
  padding: 30px 20px;
  flex: 1;
}

.audio-player-container {
  width: 100%;
}

/* Responsive design */
@media (max-width: 600px) {
  .modal-dialog {
    width: 95%;
    margin: 10px;
  }
  
  .modal-header {
    padding: 16px;
  }
  
  .modal-body {
    padding: 20px 16px;
  }
}
</style>